// extracted by mini-css-extract-plugin
export default {"container":"verifyEmailComp_container__xDydy","textPostion":"verifyEmailComp_textPostion__zQ4cf","btn":"verifyEmailComp_btn__yVhrb"};